import { StyleSheet } from 'react-native';

export const messageStyles = StyleSheet.create({
  messageText: {
    flexWrap: 'wrap',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 22,
  },
});
